<footer>
  <div class="footerAddress">
    <div class="contact-support-hide" *ngIf="(footerType === '')"></div>
    <div *ngIf="(footerType !== '')" class="contact-support">
      <img alt="User Logo" class="user-icon" src="/assets/images/user_icon.svg" />
      <span>{{assistanceText.textToDisplay}}</span>
      <a *ngIf="footerType === 'type1'" href="javascript:void(0)" class="need-assistance" (click)="contactSupport()">
        {{contactSupportText.textForFooterType1}}</a>
      <a *ngIf="footerType === 'type2'" href="{{contactSupportLink}}" class="need-assistance">
        {{contactSupportText.textForFooterType2}}</a>
    </div>
    <div class="col-lg-12 col-md-12 default-footer">
      <div class="col-lg-5 offset-lg-1 col-md-6 Privacy-term">
        {{registrationFooter1 }}<br>
        <a href="{{lnkPrivacyPolicy}}" target="_blank"> {{privacyPolicyText}} </a>
        | <a href="{{lnkTermsOfUse}}" target="_blank">{{termsOfUseText}}</a>
      </div>
    </div>
  </div>
</footer>